export class AccordionGridStyle {
  imageColumnWidth = '';
  columnGap = '';

  static normalize(styles: Partial<AccordionGridStyle>): AccordionGridStyle {
    const pureStyles = new AccordionGridStyle();

    pureStyles.imageColumnWidth = styles.imageColumnWidth ?? pureStyles.imageColumnWidth;
    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;

    return pureStyles;
  }
}
